import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseResourceWithRetry } from "./BasePlainResource";
import omit from "lodash/omit";
const createClearAndMerge = (clear) => (a, b) => ({
    ...omit(a, clear),
    ...b
});
class CalculationResource extends BaseResourceWithRetry {
    constructor() {
        super(...arguments);
        this.namespaces = [];
        this.clear = [];
        this.undefinedVariables = {};
    }
    pk() {
        return `${this.id}_${this.formContext}_${this.context}`;
    }
    static url(urlParams) {
        return super.listUrl(urlParams);
    }
    static merge(first, second) {
        const existing = first;
        const partial = second;
        const isPartial = (partial.namespaces && partial.namespaces.length > 0) ||
            (partial.clear && partial.clear.length > 0);
        if (!isPartial)
            return this.fromJS(second);
        const clearMerge = createClearAndMerge(partial.clear || []);
        const props = {
            id: partial.id || existing.id,
            context: partial.context || existing.context,
            formContext: partial.formContext || existing.formContext,
            formTemplate: partial.formTemplate || existing.formTemplate,
            namespaces: [
                ...new Set([
                    ...existing.namespaces.filter(x => partial.clear.includes(x)),
                    ...partial.namespaces
                ])
            ],
            clear: partial.clear,
            calcRules: clearMerge(existing.calcRules, partial.calcRules),
            model: {
                ...existing.model,
                resolves: {
                    ...existing.model.resolves,
                    ...partial.model.resolves
                },
                namespacedCGFSections: clearMerge(existing.model.namespacedCGFSections, partial.model.namespacedCGFSections)
            },
            customSubmitFields: clearMerge(existing.customSubmitFields, partial.customSubmitFields),
            variables: clearMerge(existing.variables, partial.variables),
            services: clearMerge(existing.services, partial.services),
            validators: clearMerge(existing.validators, partial.validators),
            macros: clearMerge(existing.macros, partial.macros),
            undefinedVariables: clearMerge(existing.undefinedVariables, partial.undefinedVariables)
        };
        return this.fromJS(props);
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            invalidIfStale: true,
            dataExpiryLength: Infinity
        };
    }
}
CalculationResource.urlRoot = legacyApiResourceUrl("AppLoanLeasing/VulcanRawScripts");
export { CalculationResource };
//# sourceMappingURL=CalculationResource.js.map